import React, { Component } from "react";
import { Row, Col } from "antd";
import SideMenuButton from "./sidemenubutton";
import { useHistory } from "react-router-dom";
// import { useRouter } from 'next/router'
import { useRouter } from "react-dom";
import Constants from "../data/constants";
import {
  LayoutDashboard,
  MonitorPlay,
  FolderOpen,
  ListMusic,
  LayoutTemplate,
  CalendarClock,
  CalendarDays,
  AppWindow,
  BarChart2,
  ClipboardList,
  FileVideo,
  Trash2,
  Key,
  Layers,
  Building2,
  MapPin,
  LogOut,
  HelpCircle,
} from "lucide-react";
import { connect } from "react-redux";
import { logout, updateGlobalSearch, selectPage } from "../actions";
import PermissionManager from "../managers/PermissionManager";
import PlanLimitsManager from "../managers/PlanLimitsManager";
import { constants } from "react-smooth-dnd";
import { checkIsAPINew } from "../Config";
import { useProLanguage, PRO_TRANSLATIONS } from "../global/ProLanguageContext";

const ICON_MAP = {
  [Constants.BRAND_PAGE]: Building2,
  [Constants.DASHBOARD_PAGE]: LayoutDashboard,
  [Constants.BRANCH_PAGE]: MapPin,
  [Constants.BRAND_PLAYLIST_PAGE]: ListMusic,
  [Constants.BRAND_MEDIA_PAGE]: FolderOpen,
  [Constants.BRAND_MEDIA_TRASH_PAGE]: Trash2,
  [Constants.ACTIVITYLOG_PAGE]: ClipboardList,
  [Constants.MEDIALOG_PAGE]: FileVideo,
  [Constants.ANALYTICS_PAGE]: BarChart2,
  [Constants.SCREEN_PAGE]: MonitorPlay,
  [Constants.CAMPAIGN_PAGE]: LayoutTemplate,
  [Constants.CAMPAIGN_CONTENT_PAGE]: LayoutTemplate,
  [Constants.CAMPAIGN_CONTENT_CHANNEL_PAGE]: LayoutTemplate,
  [Constants.TIMELINE_PAGE]: CalendarClock,
  [Constants.LAYOUT_PAGE]: Layers,
  [Constants.PLAYLIST_PAGE]: ListMusic,
  [Constants.MEDIA_PAGE]: FolderOpen,
  [Constants.MEDIA_TRASH_PAGE]: Trash2,
  [Constants.EVENT_PAGE]: CalendarDays,
  [Constants.WIDGET_PAGE]: AppWindow,
  [Constants.LICENSE_PAGE]: Key,
};

const SideMenu = (props) => {
  const history = useHistory();
  const { lang } = useProLanguage();
  const navT = PRO_TRANSLATIONS[lang].nav;
  return <SideMenuClass {...props} history={history} navT={navT} />;
};

class SideMenuClass extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      history = null,
      selectedBranchData,
      selectedBrandData,
      selectPage,
      userdata,
      collapsed = false,
      navT = {},
    } = this.props;

    const { router } = this.props;

    const filteredMenu = Constants.SIDEMENU_BUTTONS.filter((obj) => {
      const { require = [] } = obj;

      const requiresBrand = Constants.checkPageRequirements(obj.id, "brand");
      const requiresBranch = Constants.checkPageRequirements(obj.id, "branch");

      console.log(
        `check requirements for ${obj.id} => ${requiresBrand} ${requiresBranch}`,
      );
      console.log(
        `data requirements for ${obj.id} => ${selectedBrandData} ${selectedBranchData}`,
      );

      if (obj.id == Constants.BRANCH_PAGE) {
        const matchBrand = requiresBrand && selectedBrandData;
        const matchNoBrand = !requiresBrand && !selectedBrandData;
        const matchBranch = requiresBranch && selectedBranchData;
        const matchNoBranch = !requiresBranch && !selectedBranchData;
        console.log(
          "MatchBrand " +
            matchBrand +
            " MatchNoBrand " +
            matchNoBrand +
            " MatchBranch " +
            matchBranch +
            " MatchNoBranch " +
            matchNoBranch,
        );
      }

      if (
        (requiresBrand && selectedBrandData !== null) ||
        (!requiresBrand && selectedBrandData === null)
      ) {
        // result = result && true;
      } else {
        return false;
      }
      if (
        (requiresBranch && selectedBranchData !== null) ||
        (!requiresBranch && selectedBranchData === null)
      ) {
        // result = result && true;
      } else {
        return false;
      }

      return true;
      // if (requiresBrand && !selectedBrandData) {
      //     return false;
      // }
      // if (requiresBranch && !selectedBranchData) {
      //     return false;
      // }

      // return true;
    });

    console.log(
      "+++++++++++++++++++++++++ filteredMenu " +
        JSON.stringify(filteredMenu.map((e) => e.title)),
    );
    const renderButtons = filteredMenu
      .filter((obj) => {
        let hasPermission = false;

        if (!checkIsAPINew()) {
          console.log("checkIsAPINew false");
          // hasPermission = (obj.id == Constants.DASHBOARD_PAGE) || (obj.id == Constants.ACTIVITYLOG_PAGE) || (obj.id == Constants.MEDIALOG_PAGE) || ((obj.id == Constants.ANALYTICS_PAGE)) || (userdata && userdata.user && userdata.user.userid == 1 && obj.id == Constants.LICENSE_PAGE) || (obj.id == Constants.MEDIA_TRASH_PAGE) ? true : PermissionManager.checkPermission(obj.id, PermissionManager.PERMISSION_TYPE_LIST)
          hasPermission =
            userdata && userdata.user && userdata.user.userid == 1
              ? true
              : PermissionManager.checkPermission(
                  obj.id,
                  PermissionManager.PERMISSION_TYPE_LIST,
                );
          console.log(
            `check list permission for ${obj.id} => ${hasPermission}`,
          );
        } else {
          console.log("checkIsAPINew true");
          hasPermission =
            userdata && userdata.user && userdata.user.userid == 1
              ? true
              : PermissionManager.checkPermission(
                  obj.id,
                  PermissionManager.PERMISSION_TYPE_LIST,
                );
          console.log(
            `check list permission for ${obj.id} => ${hasPermission}`,
          );
        }

        // Brand-level content pages only visible when ContentSharingMode is 2
        if (obj.id == Constants.BRAND_PLAYLIST_PAGE) {
          const sharingMode = selectedBrandData
            ? selectedBrandData.ContentSharingMode
            : null;
          if (sharingMode != 2) return false;
          // const isSuperAdmin = Array.isArray(userOBJ.role) && userOBJ.role.some(r => r === "SuperAdmin");
          // if (!isSuperAdmin) return false;
          // hasPermission = true;
        }
        if (
          obj.id == Constants.BRAND_MEDIA_PAGE ||
          obj.id == Constants.BRAND_MEDIA_TRASH_PAGE
        ) {
          const sharingMode = selectedBrandData
            ? selectedBrandData.ContentSharingMode
            : null;
          if (sharingMode != 2) return false;
          // hasPermission = true;
        }

        console.log(obj.id);
        console.log("hasPermission " + hasPermission);

        // const hasPermission = (obj.id == Constants.DASHBOARD_PAGE) || (obj.id == Constants.ACTIVITYLOG_PAGE) || ((obj.id == Constants.MEDIALOG_PAGE) ||obj.id == Constants.LICENSE_PAGE) || (obj.id == Constants.MEDIA_TRASH_PAGE) ? true : PermissionManager.checkPermission(obj.id, PermissionManager.PERMISSION_TYPE_LIST)

        // console.log(`check list permission for ${obj.id} => ${hasPermission}`)
        return obj.visible && hasPermission && PlanLimitsManager.isPageEnabled(obj.id);
      })
      .map((btnObj) => {
        return (
          <Col span={24} key={btnObj.id} id={`pro-nav-${btnObj.id}`}>
            {/* <Link href={`/${btnObj.url}`} replace> */}

            <SideMenuButton
              selected={this.props.selected === btnObj.id}
              key={btnObj.id + "_btn"}
              onClick={() => {
                console.log("selected side menu  " + btnObj.id);
                selectPage(btnObj.id);
                if (this.props.onNavigate) this.props.onNavigate();
              }}
              title={
                this.props.navT
                  ? this.props.navT[btnObj.id] || btnObj.title
                  : btnObj.title
              }
              icon={ICON_MAP[btnObj.id]}
              collapsed={collapsed}
            ></SideMenuButton>
            {/* </Link> */}
          </Col>
        );
      });
    return (
      <div
        id="pro-sidemenu"
        style={{
          ...Styles.container,
          display: "flex",
          flexDirection: "column",
          width: collapsed ? "64px" : "200px",
          flexShrink: 0,
          minHeight: 0,
          position: "relative",
          zIndex: 100,
          transition: "width 0.25s ease",
          overflow: "hidden",
        }}
      >
        <Row
          justify="center"
          style={{
            justifyContent: "center",
            alignContent: "flex-start",
            textAlign: "center",
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            padding: "12px 8px",
          }}
        >
          {/* <Col className="center-content" style={Styles.logocontainer} span={24}>
                        <img src="/cms/assets/svgs/cdx_logo_blackandwhite.svg"></img>
                    </Col> */}
          {renderButtons}
        </Row>
        <div
          style={{
            padding: "12px 8px",
            display: "flex",
            flexDirection: "column",
            gap: 4,
            flexShrink: 0,
            borderTop: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <div
            id="pro-sidemenu-help-btn"
            onClick={() => window.__startProTour && window.__startProTour()}
            title="App Guide Tour"
            style={{
              width: "100%",
              height: "48px",
              display: "flex",
              alignItems: "center",
              gap: "14px",
              padding: collapsed ? "10px 0" : "10px 20px",
              justifyContent: collapsed ? "center" : "flex-start",
              borderRadius: "8px",
              backgroundColor: "transparent",
              color: "rgba(255,255,255,0.7)",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
              transition: "background 0.2s, color 0.2s",
              userSelect: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.08)";
              e.currentTarget.style.color = "rgba(255,255,255,0.95)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "rgba(255,255,255,0.7)";
            }}
          >
            <HelpCircle size={20} />
            {!collapsed && <span>{navT.help || "Help"}</span>}
          </div>
          <div
            title="Sign Out"
            onClick={() => this.props.logout()}
            style={{
              width: "100%",
              height: "48px",
              display: "flex",
              alignItems: "center",
              gap: "14px",
              padding: collapsed ? "10px 0" : "10px 20px",
              justifyContent: collapsed ? "center" : "flex-start",
              borderRadius: "8px",
              backgroundColor: "transparent",
              color: "rgba(255,255,255,0.7)",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
              transition: "background 0.2s, color 0.2s",
              userSelect: "none",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(239,68,68,0.15)";
              e.currentTarget.style.color = "#fca5a5";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "rgba(255,255,255,0.7)";
            }}
          >
            <LogOut size={20} />
            {!collapsed && <span>{navT.logout || "Sign Out"}</span>}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
  };
};

export default connect(mapStateToProps, {
  logout,
  updateGlobalSearch,
  selectPage,
})(SideMenu);

const Styles = {
  container: {
    backgroundColor: "#1e293b",
    color: "white",
    fontFamily: "Kanit",
    width: "100%",
    height: "100%",
    flexFlow: "row wrap",
    position: "relative",
    zIndex: 100,
  },

  logocontainer: {
    height: "100px",
    lineHeight: "100px",
    color: "white",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
};
